import React, { useRef } from 'react'
import { OverlayTrigger, Popover as ReactPopover } from 'react-bootstrap'
import '../../globals/scss/components/popover.scss'
import PropTypes from 'prop-types'
import { componentOrElement } from 'prop-types-extra'

const propTypes = {
  /**
   * A component instance, DOM node, or function that returns either.
   * The `container` element will have the Overlay appended to it via a React portal.
   */
  container: PropTypes.oneOfType([componentOrElement, PropTypes.func]),
  /**
   * Specify which action or actions trigger Overlay visibility
   *
   * @type {'hover' | 'click' |'focus' | Array<'hover' | 'click' |'focus'>}
   */
  trigger: PropTypes.oneOf(['click', 'hover', 'focus']),
  /** Sets the direction the Popover is positioned towards. */
  placement: PropTypes.oneOf(['auto', 'top', 'bottom', 'left', 'right']),
  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      show: PropTypes.number,
      hide: PropTypes.number,
    }),
  ]),
  /** The initial visibility state of the Overlay. */
  defaultShow: PropTypes.bool,
  /** The elements to be displayed in the Popover title and body. */
  overlay: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  })
}

const defaultProps = {
  placement: 'top',
  delay: { show: 250, hide: 0 },
  defaultShow: false,
  trigger: "click"
}

const Popover = (props) => {

  const handleClose = () => {
    document.body.click()
  }

  const { defaultShow, placement, trigger, delay, overlay /*, ...others */} = props
  return (
    <OverlayTrigger
      rootClose
      placement={placement ? placement : defaultProps.placement}
      overlay={getPopover(overlay, handleClose)}
      delay={delay ? delay : defaultProps.delay}
      trigger={trigger ? trigger : defaultProps.trigger}
      defaultShow={defaultShow ? defaultShow : defaultProps.defaultShow}
      // {...others}
    > 
      {getButton()}
    </OverlayTrigger>
  )
}

const getPopover = (props, handleClose) => {
  const { title, content, placement /*, ...others */} = props
  return (
    <ReactPopover
      title={title}
      // {...others}
    >
      {popoverBody(content ? content : defaultBoxContent, handleClose)}
    </ReactPopover>
  )

}

const popoverBody = (content, handleClose) => {
  return (
    <>
      <div className="popoverClose" onClick={handleClose} />
      {content}
    </>
  )
}

const getButton = () => {
  return (
    <span className="popoverTrigger"></span>
  )
}
Popover.propTypes = propTypes
Popover.defaultProps = defaultProps
export default Popover
